import React from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Box } from 'transfix-ui/core'

export const ErrorInlineMessage = () => (
  <Box mt={1} p={1}>
    <InlineMessage
      type={INLINE_MESSAGE_VARIANTS.ALERT}
      message='Error loading content. Try reloading. If the issue persists contact tech support.'
    />
  </Box>
)

export default ErrorInlineMessage
